import CityPageTemplate from "../city-template/CityPageTemplate";
import { herndonVaConfig } from "./data";

export default function HerndonVaPage() {
  return <CityPageTemplate config={herndonVaConfig} />;
}